<template>
  <div class="mt-4">
    <google-button
      :sign-up="false"
      :google-id="scope + 'googleSign'"
      @onError="onError"
    />
    <clever-button />
    <classlink-button/>
    <!-- <facebook-button :sign-up="false" @onError="onError" /> -->
    <v-btn @click="qrLoginPage" outlined style="display:flex; width: 100%; text-transform: none;" class="my-2">
    <v-icon>{{ icons.mdiQrcode }} </v-icon>
    <span class="pl-3">
      Login with QR code
    </span>
  </v-btn>
    <div style="margin-top: 30px; margin-bottom: 30px" class="signup_or_line">
      <hr />
      <span>{{ $t('navbar.signup.form.or') }}</span>
    </div>

    <form
      ref="loginForm"
      :data-vv-scope="scope"
      @submit.prevent="submitLogin(scope)"
    >
      <v-alert v-for="e in error" :key="e" :value="true" type="error">
        {{ e }}
      </v-alert>
      <v-text-field
        outlined
        v-model="name"
        v-validate="{ required: true, min: 3, max: 100 }"
        :error-messages="getTranslation(errors.collect('name'))"
        :label="$t('navbar.signup.form.username')"
        name="name"
        required
      />
      <v-text-field
        outlined
        v-model="password"
        v-validate="'required'"
        :error-messages="getTranslation(errors.collect('password'))"
        :append-icon="
          show1 ? '$vuetify.icons.mdiEye' : '$vuetify.icons.mdiEyeOff'
        "
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
        :label="$t('navbar.signup.form.password')"
        name="password"
        required
      />
      <v-btn block color="primary" depressed class="mb-4" type="submit">
        {{ $t('navbar.signup.form.submit') }}
      </v-btn>
      <div class="pt-3 text-center">
        <a @click="forgotPass">
          {{ $t('forms.password_change.forgotPassword') }}
        </a>
      </div>
    </form>
  </div>
</template>

<script>
import {
  mdiQrcode,
} from '@mdi/js'
export default {
  components: {
    'clever-button': () =>
      import('~/components/forms/account/social/CleverButton'),
    'classlink-button': () =>
      import('~/components/forms/account/social/ClasslinkButton'),
    'facebook-button': () =>
      import('~/components/forms/account/social/FacebookButton'),
    'google-button': () =>
      import('~/components/forms/account/social/GoogleButton'),
  },
  props: {
    scope: {
      type: [String],
      required: false,
      default: 'login-form',
    },
    accountType: {
      type: [String],
      required: false,
      default: 'regular',
    },
    classcode: {
      type: [String],
      required: false,
      default: '',
    },
  },
  inject: ['$validator'],
  data: () => ({
    icons: {
        mdiQrcode,
      },
    show1: false,
    loginType: 'username',
    url: '',
    name: '',
    password: '',
    dictionary: {
      custom: {
        name: {
          required: () => 'navbar.signup.form.errors.username',
          max: 'navbar.signup.form.errors.max',
          regex: 'navbar.signup.form.errors.regex',
        },
        password: {
          required: () => 'navbar.signup.form.errors.password',
        },
      },
    },
    error: null,
  }),
  methods: {
    toggleSignupDialog() {
      this.$store.dispatch('setSignupDialog', !this.$store.state.signupDialog)
    },
    qrLoginPage(){
      this.$store.dispatch('setLoginDialog', false)
      this.$router.push(this.localePath('/login/qr/') )
    },
    forgotPass() {
      this.$store.dispatch('setLoginDialog', false)
      this.$router.push(this.localePath('/account/reset-password') )
    },
    onError: function (error) {
      this.error = error
    },
    async submitLogin(scope) {
      const vue = this
      const message = this.$t('navbar.login.loggedin')
      this.error = []
      if (!(await this.$validator.validateAll(scope))) return
      if (this.name.includes('@')) {
        this.loginType = 'email'
      } else {
        this.loginType = 'username'
      }
      try {
        let data = {
          [this.loginType]: this.name,
          password: this.password,
        }
        const res = await this.$auth.loginWith('local', {
          data: data,
        })

        // transfer story if was guest mode
        if (this.$route.path.includes('/studio/edit/') && !this.$auth.user) {
          await this.$api.setUserForGuestStory(this.$store.state.StudioLauncher.projectDetails.slug, {username: res.data.user.username})
        } 
        this.$auth.setUserToken(res.data.access_token, res.data.refresh_token)
        this.$auth.setUser(res.data.user)
        
        if (this.$store.state.i18n.locale != this.$auth.user.profile.lang) {
          this.changeLangCookie(this.$auth.user.profile.lang)
        }

        this.$store.dispatch('setLoginDialog', false)
        this.$toast.success(message, {
          duration: 5000,
        })
        if (this.$route.path.includes('/studio/edit/') && this.$store.state.StudioLauncher.projectDetails.slug) {
          console.log('do not redirect and return')
          return
        }
        // redirect if not working on a book

        if (this.$route.path.includes('/login')) {
          if (this.$store.state.auth.redirect) {
            this.$router.push(this.localePath(this.$store.state.auth.redirect))
          } else {
            this.$router.push(this.localePath('/') )
          }
        }
      } catch (e) {
        if (e.response) {
          const data = e.response.data
          Object.keys(data).map((k) => (this.error = data[k]))
        }
      }
    },
    changeLangCookie(code) {
      this.$cookies.set('locale', code, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
      this.$cookies.set('i18n_redirected', code, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
      this.$i18n.locale = code
      this.$dayjs.locale(code)
      // this.$i18n.setLocale(code)
    },
    getTranslation(path) {
      return this.$t(String(path))
    },
  },
}
</script>
